import { render, staticRenderFns } from "./areas-map.vue?vue&type=template&id=a9fc02c6"
import script from "./areas-map.vue?vue&type=script&lang=js"
export * from "./areas-map.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports